// Сайт
export const urlRegEx =
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9а-яА-ЯёЁ-]+\.[a-zA-Z0-9а-яА-ЯёЁ-]+)(\.[a-zA-Zа-яА-ЯёЁ]{2,})(\/[^\s]*)?$/;
